import { useState } from 'react';
import {
  Button,
  Divider,
  Paper,
  Typography,
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import Visibility from '@mui/icons-material/Visibility';

import { ITicket } from '@/shared/interfaces/erp/tickets-soporte-clientes';
import ModalPerfilCliente360 from './ModalPerfilCliente360';

type CardClienteProps = {
  ticket: ITicket;
};

export default function CardCliente({ ticket }: CardClienteProps) {
  const [openModal, setOpenModal] = useState(false);

  return (
    <Paper elevation={1} sx={{ p: 2, mb: 2, borderRadius: 2 }}>
      <Typography
        variant="h6"
        fontWeight="bold"
        sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'primary.main', mb: 1 }}
      >
        <PersonIcon fontSize="small" />
        Cliente
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <Typography variant="caption" color="text.secondary">
        Razon Social
      </Typography>
      <Typography variant="body2" fontWeight={500} gutterBottom>
        {ticket.cliente_razon_social || '-'}
      </Typography>

      <Typography variant="caption" color="text.secondary">
        Identificacion
      </Typography>
      <Typography variant="body2" fontWeight={500} gutterBottom>
        {ticket.cliente_identificacion || '-'}
      </Typography>

      <Typography variant="caption" color="text.secondary">
        Contrato
      </Typography>
      <Typography variant="body2" fontWeight={500} gutterBottom>
        {ticket.contrato_data?.numero_referencia || ticket.contrato_data?.codigo || '-'}
      </Typography>

      {ticket.cliente && (
        <Button
          variant="outlined"
          size="small"
          fullWidth
          startIcon={<Visibility />}
          sx={{ mt: 2, textTransform: 'none' }}
          onClick={() => setOpenModal(true)}
        >
          Ver Perfil 360
        </Button>
      )}

      <ModalPerfilCliente360
        open={openModal}
        onClose={() => setOpenModal(false)}
        clienteId={ticket.cliente}
        contratoId={ticket.contrato}
        clienteNombre={ticket.cliente_razon_social}
      />
    </Paper>
  );
}
